(function() {
'use strict';

angular
    .module('TR')
    .directive('datePicker', datepicker);

function datepicker(resourceService, $timeout, dateUtil) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl: (element, attr) => {
            let base = 'partials';
            if (attr.templateVersion) {
                return `${base}/booking/template?name=DatePicker&version=${attr.templateVersion}`;
            }
            return `${base}/home/directivetemplate?type=DatePicker`;
        },
        scope: {
            select: '&',
            minDate: '=',
            maxDate: '=',
            defaultTime: '=',
            currentDate: '=',
            dates: '=',
            showApplyButton: '=',
            showTime: '=',
            isTimeApprovedByCustomer: '=?',
            requiresTimeApproval: '=',
            timeLabelKey: '@',
            timeErrorMsg: '@',
            placeholder: '@',
            noInitialDate: '@',
            numberOfMonths: '@',
            datepickerClass: '=',
            focusTracker: '@',
            isDisabled: '=?',
            isDisabledPlaceholder: '@',
            isRequired: '=?',
            isReadonly: '=?'
        },
        link: _linker,
        controller: _controller,
        transclude: true
    };

    function _controller($scope, $element) {
        this.dateEl = $element.find('.datepicker-wrapper');
    }

    function _linker(scope, el, attr) {
        let selectedDate = parseCurrentDate();
        const dateEl = el.find('.datepicker-wrapper');

        if (TRPCONFIG.IsTouchDevice) {
            dateEl.attr('readonly', 'true');
        }

        // Used as `ng-model` primarily to enable `ng-invalid` etc. on field
        scope.fieldVals = {
            date: {}
        };

        // Re-wire 'focus-tracker' attr to input field
        if (scope.focusTracker && scope.$parent.ft) {
            scope.$parent.ft.init(dateEl);
        }

        // `required` attr has no value
        if (attr.hasOwnProperty('required')) {
            scope.isRequired = true;
        }

        scope.timeValue = {};

        const dp = dateEl.datepicker({
            numberOfMonths: parseInt(scope.numberOfMonths) || 1,
            dateFormat: 'dd-M-yy',
            firstDay: 1,

            minDate: parseMinDate(scope.minDate), // `true` for current date
            maxDate: dateUtil.parseDate(scope.maxDate),
            beforeShowDay,

            // http://www.objectpartners.com/2012/06/18/jquery-ui-datepicker-ie-focus-fix/
            // http://bugs.jqueryui.com/ticket/9125 is not important enough apparently
            lastDisplay: null,

            onSelect() {
                selectDate();
                this.lastDisplay = new Date().getTime();
                this.blur();
            },
            onClose() {
                // This deals with anything typed into the field that changed the value
                const dpDate = dp.datepicker('getDate') || '';
                const expected = selectedDate || '';
                if (dpDate.toString() !== expected.toString()) {
                    selectDate();
                } else {
                    syncField();
                }
            },
            beforeShow() {
                return !this.lastDisplay || (new Date().getTime()) - this.lastDisplay > 100;
            },
            prevText: '',
            nextText: '',
            isRTL: TRPCONFIG.Rtl
        });

        function selectDate() {
            selectedDate = dp.datepicker('getDate');

            // $apply avoiding $digest errors
            scope.$evalAsync(() => {
                if (selectedDate == null) {
                    scope.select({ date: null });
                } else if (!scope.showTime) {
                    scope.select({ date: dateUtil.serialiseDate(selectedDate) });
                } else if (!scope.showApplyButton) {
                    scope.setDepartureDateAndTime();
                }
                syncField();
            });
        }

        if (scope.showTime && !scope.showApplyButton) {
            scope.$watchGroup(
                ['tp.hours', 'tp.minutes'], vals => {
                    if (vals[0] && vals[1]) {
                        // Timer ensures field is ready
                        $timeout(selectDate);
                    }
                }
            );
        }

        //  terrible hack to prevent the default behaviour of jQuery datepicker
        //  so we can have no selected and highlighted date
        $timeout(function() {
            const currDate = parseCurrentDate();
            if (scope.noInitialDate === 'true') {
                scope.$apply(function() {
                    if (!scope.currentDate || !dateUtil.isValid(currDate)) {
                        dp.datepicker('setDate', null);
                        $(el).find('td.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
                    } else {
                        dp.datepicker('setDate', currDate);
                        scope.currentDate = dateUtil.serialiseDate(currDate);
                    }
                });
            } else {
                let searchDates = JSON.parse(sessionStorage.getItem('searchDates'));
                if (searchDates) {
                    document.getElementsByClassName('searchDates')[0].value = searchDates.startDate;
                }
                dp.datepicker('setDate', currDate);
            }
        });

        scope.$watch('minDate', function(val) {
            if (val != null) {
                dateEl.datepicker('option', 'minDate', parseMinDate(val));

                // If select date is called on mobile then the datepicker freezes up.
                if (TRPCONFIG.Domain.DeviceType === 'Desktop') {
                    selectDate();
                }
            }
        });

        scope.$watch('maxDate', function(val) {
            if (val != null) {
                dateEl.datepicker('option', 'maxDate', dateUtil.parseDate(val));
            }
        });

        scope.setDepartureDateAndTime = function() {
            let dateOb = null;

            if (scope.tp && (!scope.tp.hours || !scope.tp.minutes)) {
                scope.$emit('flash:error', resourceService.get(scope.timeErrorMsg));
            }
            if (dateUtil.isValid(selectedDate)) {
                let hours = scope.tp && scope.tp.hours ? scope.tp.hours : selectedDate.getHours();
                let minutes = scope.tp && scope.tp.minutes ? scope.tp.minutes : selectedDate.getMinutes();
                dateOb = new Date(
                    selectedDate.getFullYear(),
                    selectedDate.getMonth(),
                    selectedDate.getDate(),
                    hours,
                    minutes
                );
            }
            const serialisedDate = dateUtil.serialiseDate(dateOb);

            if (_.isFunction(scope.select)) {
                scope.select({ date: serialisedDate, back: true });
            } else {
                scope.select = serialisedDate;
            }
        };

        if (scope.showTime) {
            //this is sort of a nextTick hack
            $timeout(function() {
                el.find('button').text(resourceService.get('APPLYDATEANDTIME'));
            }, 0);
        }

        function syncField() {
            // Ensure field contains current value
            dp.datepicker('setDate', selectedDate);
            dateEl.trigger('input');
        }

        function parseCurrentDate() {
            return dateUtil.parseDate(scope.currentDate);
        }

        function parseMinDate(val) {
            return val === true ?
                dateUtil.zeroTime(new Date()) :
                dateUtil.parseDate(val);
        }

        function beforeShowDay(date) {
            let allowed = true;
            if (scope.dates && Object.keys(scope.dates).length > 0) {
                const dateStr = dateUtil.format(date, 'yyyy-MM-dd');
                allowed = scope.dates[dateStr] !== undefined;
            }
            return [allowed, '', ''];
        }
    }
}
})();
